/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateSlotResponseDto = {
    /**
     * Availability window UUID
     */
    id: string;
    /**
     * Start time (UTC)
     */
    startTime: string;
    /**
     * End time (UTC)
     */
    endTime: string;
    /**
     * Status
     */
    status?: CreateSlotResponseDto.status;
    /**
     * Supported session modes
     */
    modes: Array<'online' | 'client_location' | 'expert_location'>;
};
export namespace CreateSlotResponseDto {
    /**
     * Status
     */
    export enum status {
        AVAILABLE = 'available',
        BOOKED = 'booked',
    }
}

